import React from 'react';
import '../css/HomeRedesign.css';

import HeroSliderSection from '../components/HeroSliderSection';
import ServicesSection from '../components/ServicesSection';
import ChannelsSection from '../components/ChannelsSection';
import AboutSection from '../components/AboutSection';
import ContactSection from '../components/ContactSection';


import CapsosImageWall from '../components/CapsosImageWall';
import FacebookFeed from '../components/FacebookFeed';
import EquiposDestacados from '../components/EquiposDestacados';

const HomeCorporate = () => {
  return (
    <div className="home-corporate">



      <main>
        <HeroSliderSection />
        <ServicesSection />

        <FacebookFeed />
        <ChannelsSection />
        <EquiposDestacados/>
        <AboutSection />
        <CapsosImageWall />
        <ContactSection />
      </main>


    </div>
  );
};

export default HomeCorporate;